export enum AnalyticsType {
  GOOGLE_ANALYTICS,
  FACEBOOK_PIXEL,
};

export interface FPObjectProperties {
  content_category: string | undefined;
  content_ids: (string | number)[] | undefined;
  content_name: string | undefined;
  content_type: 'product' | 'product_group' | undefined;
  contents: { id: string | number, quantity: number, type: 'buy' | 'gift' }[] | undefined;
  currency: string | undefined;
  num_items: number | undefined;
  predicted_ltv: number | undefined;
  search_string: string | undefined;
  status: boolean | undefined;
  value: number | undefined;
}
